import React from 'react'

const OurVoice = () => (
  <div>
    <h2>OurVoice</h2>
  </div>
)

export default OurVoice


// WEBPACK FOOTER //
// ./src/components/OurVoice/OurVoice.js